import React, { useCallback, useEffect, useMemo, useState } from 'react';

import {
  getStripePlanDuration,
  isImmediateUpgrade,
} from '../../../utils/subscriptionConstants';
import { AudioMessage } from '../../AudioMessage/AudioMessage';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { CancelSubscriptionScheduleModal } from './CancelSusbcriptionScheduleModal';
import PlanList from './PlansListView';

function UpdateSubscriptionView({
  plans,
  userSubscription,
  openCancelModal,
  updateSubscriptionPlan,
  cancelSubscriptionCondition,
  waiting,
  message,
  closeUpdateSubscriptionPlan,
  refundAmountMessage,
}) {
  const [selectedPlan, setSelectedPlan] = useState('');
  const [userPlan, setUserPlan] = useState('');
  // const [warfareOnlyStatus, setWarfareOnlyStatus] = useState(false);

  const [subsctiptionSent, setSubscriptionSent] = useState(false);
  const [openCancelUpdate, setOpenCancelUpdate] = useState(false);

  useEffect(() => {
    setSelectedPlan(userSubscription.planId);
    setUserPlan(userSubscription.planId);
    if (userSubscription.planId === userSubscription.warfarePlanId) {
      setWarfareOnlyStatus(true);
    }
    if (subsctiptionSent) {
      setTimeout(() => {
        setSubscriptionSent(false);
      }, 5000);
    }
  }, [userSubscription]);

  useEffect(() => {
    if (subsctiptionSent && !waiting) {
      closeUpdateSubscriptionPlan();
    }
  }, [waiting, subsctiptionSent]);

  const updateLinkClass = useMemo(
    () =>
      (selectedPlan === userPlan && !userSubscription.scheduledPlan) ||
      userSubscription.scheduledPlan === selectedPlan
        ? 'update-link disabled'
        : 'update-link',
    [selectedPlan, userPlan, userSubscription],
  );

  const handleUpdateSubscription = useCallback(() => {
    if (userSubscription.scheduledPlan === selectedPlan) return;
    if (selectedPlan === userPlan && !openCancelUpdate) {
      if (!userSubscription.scheduledPlan) return;

      setOpenCancelUpdate(true);
    } else {
      updateSubscriptionPlan(selectedPlan);
      setSubscriptionSent(true);
      setOpenCancelUpdate(false);
    }
  }, [selectedPlan, userPlan, openCancelUpdate]);

  const plansRate = useMemo(
    () =>
      plans.filter(
        (p) =>
          p.id !== userSubscription.warfarePlanId &&
          !(
            userSubscription.planId === userSubscription.warfarePlanId &&
            p.interval === 'month' &&
            p.interval_count === 1
          ),
      ),
    [plans, userSubscription],
  );

  // const planWarfare = useMemo(
  //   () => plans.find((p) => p.id === userSubscription.warfarePlanId),
  //   [plans, userSubscription],
  // );

  // const isMonthlyToLongTermUpgrade = useMemo(() => {
  //   const selectedPlanData = plans.find((p) => p.id === selectedPlan);
  //   return (
  //     userSubscription.interval === 'Monthly' &&
  //     selectedPlanData &&
  //     selectedPlanData.id !== userSubscription.warfarePlanId &&
  //     (selectedPlanData.interval_count === 6 ||
  //       selectedPlanData.interval === 'year')
  //   );
  // }, [
  //   selectedPlan,
  //   plans,
  //   userSubscription.interval,
  //   userSubscription.warfarePlanId,
  // ]);
  const isImmediatePlanUpgrade = useMemo(() => {
    const currentPlanData = plans.find((p) => p.id === userPlan);
    const selectedPlanData = plans.find((p) => p.id === selectedPlan);
    if (!currentPlanData || !selectedPlanData) return false;

    return isImmediateUpgrade(
      {
        isOccupational: currentPlanData.isOccupational,
        duration: getStripePlanDuration(currentPlanData),
      },
      {
        isOccupational: selectedPlanData.isOccupational,
        duration: getStripePlanDuration(selectedPlanData),
      },
    );
  }, [selectedPlan, userPlan, plans]);

  const bestValue = useMemo(() => {
    const plansAmount = plansRate?.map((p) => p.amount);
    return Math.max(...plansAmount);
  }, [plansRate]);
  return (
    <div className="update-subscription-view">
      {plansRate.map((plan) => (
        <>
          {plan.interval_count !== 1 && <AudioMessage align="center" />}

          <PlanList
            plan={plan}
            setSelectedPlan={setSelectedPlan}
            isSelected={selectedPlan === plan.id}
            userSubscription={userSubscription}
            userPlan={userPlan}
            key={plan.id}
            bestValue={plan.amount === bestValue}
          />
        </>
      ))}
      {/* {planWarfare && (
        <>
          <div className="warfare-subs-title">
            Warfare & Qualifications Only Subscription
          </div>
          <PlanList
            plan={planWarfare}
            setSelectedPlan={setSelectedPlan}
            isSelected={selectedPlan === planWarfare.id}
            userSubscription={userSubscription}
            userPlan={userPlan}
            isWarfarePlan
          />
        </>
      )} */}
      {/* {warfareOnlyStatus ? (
        <div>
          NOTE: If you decide to change your current subscription plan, the
          upgrade will take effect immediately and you will be charged for the
          new subscription. Additionally, a refund for the unused time on the
          Warfare Only plan will be issued, which may take 4-5 business days to
          process.
        </div> */}
      {isImmediatePlanUpgrade ? (
        <div>
          NOTE: The change will take effect immediately. You will receive a
          prorated credit for the unused time on your current plan and be
          charged for the new plan right away. Any active discount will be
          removed and not applied to the new plan.
        </div>
      ) : (
        // ) : isMonthlyToLongTermUpgrade ? (
        //   <div>
        //     NOTE: The change will take effect immediately. You will receive a
        //     prorated refund for unused time on your Monthly plan (up to $16) and
        //     be charged for the new plan right away. Any active discount will be
        //     removed and not applied to the new plan.
        //   </div>
        <div>
          NOTE: if you change your current plan, you will not be charged until
          the end of your current subscription (Currently{' '}
          {userSubscription.next_bill_date})
        </div>
      )}
      {waiting ? (
        <div className="waiting">
          <CircularLoading className="button-loading-gif" />
        </div>
      ) : (
        <>
          <div className="link-container">
            <div
              className={updateLinkClass}
              data-test="update-subscription-button"
              onClick={() => handleUpdateSubscription()}
            >
              Update Subscription
            </div>
          </div>

          {refundAmountMessage?.text && (
            <>
              <div className="message-success text-center ml-0 mt-2">
                {refundAmountMessage.text}
              </div>
            </>
          )}
          {cancelSubscriptionCondition &&
            userSubscription.type === 'stripe' && (
              <div className="link-container">
                <div
                  className="cancel-link"
                  onClick={() => openCancelModal(true)}
                >
                  Cancel Subscription
                </div>
              </div>
            )}
          {cancelSubscriptionCondition &&
            userSubscription.type !== 'stripe' && (
              <p>
                To manage your subscription, visit your iTunes account settings.
              </p>
            )}
          <div
            className="back-link"
            onClick={() => closeUpdateSubscriptionPlan()}
          >
            Go Back
          </div>
        </>
      )}
      {openCancelUpdate && (
        <CancelSubscriptionScheduleModal
          open={openCancelUpdate}
          onClose={() => {
            setOpenCancelUpdate(false);
          }}
          callback={() => handleUpdateSubscription()}
        />
      )}
    </div>
  );
}

export default UpdateSubscriptionView;
